import { Component, Input, OnInit, SimpleChanges, OnChanges, ViewChild, Output, EventEmitter } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ParametersDTO } from 'src/app/infraestructure/interfaces/parameters/ParametersDTO';
import { GuardarVehiculoSubcontratadoDTO } from 'src/app/infraestructure/interfaces/referente/GuardarVehiculoSubcontratadoDTO';
import { ParametricListsService } from 'src/app/infraestructure/services/parametric-lists/parametric-lists.service';

@Component({
  selector: 'app-gestion-vehiculos-subcontratados',
  templateUrl: './gestion-vehiculos-subcontratados.component.html',
  styleUrls: ['./gestion-vehiculos-subcontratados.component.scss']
})
export class GestionVehiculosSubcontratadosComponent implements OnInit, OnChanges {
  
  @ViewChild('reqRoute', { static: true }) reqRoute: any;

  @Output() dataVehicleSub = new EventEmitter<GuardarVehiculoSubcontratadoDTO>();

  @Input() submitted: number = 0;

  vehiculo: GuardarVehiculoSubcontratadoDTO = new GuardarVehiculoSubcontratadoDTO();
  $parametricList: ParametersDTO = new ParametersDTO();
  private $topSubcription = new Subject<void>();
  
  constructor(private _listSrv: ParametricListsService,) {  }

  ngOnInit(): void {
    this._listSrv.getDataLists('TIP_CLASE_VEHICULO')
    .pipe(takeUntil(this.$topSubcription))
    .subscribe(res => {
      if(res.code === 200) this.$parametricList.typeKindVehicle = res.data;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['submitted'] && this.submitted > 0) {
      this.onSendVehicleSub();
    }
  }

  onSendVehicleSub(): any {
    if (this.reqRoute.form.valid === false) {
      this.reqRoute.form.status = "INVALID";
    } else {
      this.dataVehicleSub.emit(this.vehiculo);
    }
  }

  //Función que ajusta el formato de inputs a numericos
  validateFormat(event: any) {
    let key;
    if (event.type === 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      key = event.keyCode;
      key = String.fromCharCode(key);
    }
    const regex = /[0-9]|\./;
    if (!regex.test(key)) {
      event.returnValue = false;
      if (event.preventDefault) {
        event.preventDefault();
      }
    }
  }
}
